import { render } from "./SubAdminSetting.vue?vue&type=template&id=4b4221de&scoped=true"
import script from "./SubAdminSetting.vue?vue&type=script&lang=js"
export * from "./SubAdminSetting.vue?vue&type=script&lang=js"

import "./SubAdminSetting.vue?vue&type=style&index=0&id=4b4221de&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4221de"]])

export default __exports__